<div class="col-md-10 offset-md-1 col-lg-4 offset-lg-4" style="height:85vh; position: relative"><p></p>
<div class="card">
  <div class="card-header">
    {{pageTitle}}
  </div>

  <div class="card-body">
    <form novalidate
          (ngSubmit)="login(loginForm)"
          #loginForm="ngForm"
          autocomplete="off">
      <fieldset>

        <div class="form-group row">
          <label class="col-md-3 col-form-label"
                 for="userNameId">User Name</label>
          <div class="col-md-6">
            <input class="form-control"
                   id="userNameId"
                   type="text"
                   placeholder="User Name (required)"
                   required
                   ngModel
                   name="userName"
                   #userNameVar="ngModel"
                   [ngClass]="{'is-invalid': (userNameVar.touched || userNameVar.dirty) && !userNameVar.valid }" />
            <span class="invalid-feedback">
              <span *ngIf="userNameVar.errors?.required">
                User name is required.
              </span>
            </span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form--label"
                 for="passwordId">Password</label>

          <div class="col-md-6">
            <input class="form-control"
                   id="passwordId"
                   type="password"
                   placeholder="Password (required)"
                   required
                   ngModel
                   name="password"
                   #passwordVar="ngModel"
                   [ngClass]="{'is-invalid': (passwordVar.touched || passwordVar.dirty) && !passwordVar.valid }" />
            <span class="invalid-feedback">
              <span *ngIf="passwordVar.errors?.required">
                Password is required.
              </span>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="ml-auto">
            <button class="btn btn-primary mr-3"
                    type="submit"
                    style="width:100px"
                    [disabled]="!loginForm.valid">
              Log In
            </button>
            <button class="btn btn-outline-secondary"
                    type="button"
                    style="width:100px"
                    [routerLink]="['/']">
              Cancel
            </button>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

  <div class="alert alert-danger"
       *ngIf="errorMessage">{{errorMessage}}
  </div>
</div>
</div>